export default __webpack_public_path__ + "static/media/sport-transfer.640209ee.svg";